<section class="w-full flex flex-col justify-center">
  <div class="control" [ngStyle]="controlStyles">
    @if (labelEnabled) {
      <blaze-element-label
        [color]="props?.style?.general?.title?.color1"
        [extendInputPadding]="elementContext?.extendInputPadding"
        [fontFamily]="props?.style?.labelBlock?.fontFamily"
        [fontSize]="props?.style?.labelBlock?.fontSize"
        [fontStyle]="props?.style?.labelBlock?.fontStyle"
        [fontWeight]="props?.style?.labelBlock?.fontWeight"
        [horizontalAlign]="props?.content?.title?.align?.horizontal"
        [icon]="props?.content?.title?.icon"
        [iconColor]="props?.content?.title?.iconColor?.color1"
        [iconPosition]="props?.content?.title?.iconPosition"
        [iconSize]="props?.style?.labelBlock?.iconSize"
        [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
        [lineHeight]="props?.style?.labelBlock?.lineHeight"
        [position]="props?.content?.title?.position"
        [tooltip]="props?.content?.title?.tooltip"
        [width]="props?.content?.title?.width"
        class="!items-start"
        verticalAlign="top"
      >
        {{ labelText }}
      </blaze-element-label>
    }
    <div class="group" [ngStyle]="groupStyles">
      @if (!isReadonly) {
        <div>
          <div
            [id]="wrapperSectionKey"
            class="input"
            [ngStyle]="inputWrapperStyles"
            [class.validation-error]="hasValidationError && !signature$$.value.fullName"
            (click)="onAreaClicked($event)"
          >
            <input
              #inputText
              [formControl]="formControl"
              type="text"
              [placeholder]="placeholder"
              [ngStyle]="inputStyles"
              (focus)="isFocused = true"
              (blur)="isFocused = false"
            />
          </div>
          @if (showErrorLabel && !signature$$.value.fullName) {
            <div class="validation" [ngStyle]="validationStyles">
              {{ formState?.messages?.required || formState?.messages?.invalid }}
            </div>
          }
        </div>
      }
      <div class="header">
        {{ isHandwritten && !hasHandwriting && !isReadonly ? 'Draw Signature' : 'Signed by:' }}
      </div>
      <div
        class="signature-container"
        [class.handwritten]="isHandwritten"
        [class.readonly]="isReadonly"
        [class.validation-error]="
          hasValidationError && isHandwritten && !signature$$.value.signature
        "
      >
        <span #text class="text" [style.font-size]="fontSize$ | async">{{
          (signature$$ | async)?.fullName || ' '
        }}</span>
        <span class="text placeholder">{{ ' ' }}</span>
        <canvas #pad class="pad" [style.color]="textColor"></canvas>
        <div
          class="preview"
          [innerHTML]="sanitizer.bypassSecurityTrustHtml((signature$$ | async)?.signature ?? '')"
        ></div>
        <button class="clear" (click)="removeHandwriting()" [hidden]="!hasHandwriting">
          <mat-icon svgIcon="icon_trash_16" />
        </button>
        <mat-icon class="hint" svgIcon="icon_close_16" />
      </div>
      <div class="footer break-all">
        @let signature = (signature$$ | async) ?? {};
        @if (signature?.signedDate) {
          @if (detailsType === 'full' || detailsType === 'name') {
            {{ signature.fullName || 'Anonymous' }}
          }
          @if (detailsType === 'full') {
            -
          }
          @if (detailsType === 'full' || detailsType === 'date') {
            {{ signature.signedDate | formatValue: 'date' : { dateFormat: 'MM/dd/yyyy' } }}
          }
        }
      </div>
      @if (showErrorLabel && isHandwritten && !signature$$.value.signature) {
        <div class="validation" [ngStyle]="validationStyles">
          {{ formState?.messages?.required || formState?.messages?.invalid }}
        </div>
      }
    </div>
  </div>
</section>
